module.exports = __webpack_public_path__ + "static/media/ellipse11.0a075bec.png";